const KEY_CODES = {
  enter: 'Enter',
}

const handleKey =
  (key) =>
  (eventHandler, { preventDefault = true } = {}) =>
  (event) => {
    if (event.key === key) {
      eventHandler(event)
      if (!preventDefault) return event
    }

    return event
  }

export const handleEnter = handleKey(KEY_CODES.enter)
